import type { FC, PropsWithChildren } from 'react';

import betCityLogo from 'assets/icons/bet-city/bet-city-logo.svg';

import { SwitchLocale } from '../../switch-locale';

const BaseCard: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mx-auto md:m-auto flex flex-col items-start gap-4 max-w-[500px] w-full">
      <div className="flex justify-between items-center w-full">
        <img src={betCityLogo} className="w-[183px] md:w-[264px]" alt="bet city logo" />
        <div className="block md:hidden">
          <SwitchLocale />
        </div>
      </div>
      <div className="w-full border border-betCity-gray-200 bg-white p-4 md:p-8 rounded-xsmall">
        {children}
      </div>
    </div>
  );
};

export { BaseCard };
